import {
  User,
  Hash,
  Clock,
  Printer,
  FileText,
} from 'lucide-react';

interface Props {
  report: any;
  loading: boolean;
  printPending?: boolean;

  onGenerate?: () => void;

  onPrintTicket?: () => void;
  onDownloadPdf?: () => void;
}

const Field = ({
  label,
  value,
  icon,
}: {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
}) => (
  <div className="flex min-w-[140px] flex-col gap-1">
    <span className="text-gray-500 dark:text-gray-400 flex items-center gap-2 text-xs">
      {icon}
      {label}
    </span>

    <span className="font-medium text-black dark:text-white">
      {value}
    </span>
  </div>
);

const CashClosingXHeader: React.FC<Props> = ({
  report,
  loading,
  printPending,
  onPrintTicket,
  onDownloadPdf,
}) => {
  const formatDate = (date?: string) => {
    if (!date) return '-';

    return new Date(date).toLocaleString();
  };

  const disabledActions =
    !report || loading || printPending;

  if (!report) return null;

  return (
    <div
      className="
        flex flex-col gap-4
        border-b border-stroke
        p-5
        dark:border-strokedark
        xl:flex-row
        xl:items-center
        xl:justify-between
      "
    >
      {/* 🔹 INFO */}

      <div className="flex flex-wrap gap-6 text-sm">
        <Field
          label="Usuario"
          value={report.user ?? '-'}
          icon={<User size={14} />}
        />

        <Field
          label="Sesión"
          value={report.sessionNumber ?? '-'}
          icon={<Hash size={14} />}
        />

        <Field
          label="Apertura"
          value={formatDate(report.openingTime)}
          icon={<Clock size={14} />}
        />
      </div>

      {/* 🔹 ACCIONES */}

      <div className="flex items-center gap-3">
        <button
          onClick={onPrintTicket}
          disabled={disabledActions}
          className="
            flex items-center gap-2
            rounded-sm
            bg-[#3CA745]
            px-4 py-2
            text-sm font-medium
            text-white
            transition
            hover:bg-opacity-90
            disabled:opacity-50
          "
        >
          <Printer size={16} />

          {printPending ? 'Imprimiendo…' : 'Imprimir Ticket'}
        </button>

        <button
          onClick={onDownloadPdf}
          disabled={disabledActions}
          className="
            flex items-center gap-2
            rounded-sm
            bg-primary
            px-4 py-2
            text-sm font-medium
            text-white
            transition
            hover:bg-opacity-90
            disabled:opacity-50
          "
        >
          <FileText size={16} />

          Descargar PDF
        </button>
      </div>
    </div>
  );
};

export default CashClosingXHeader;
